module.exports = __webpack_public_path__ + "90526609c7e2e1ff067ab5fdf4f4057f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/01_CL_04.png
// module id = 101
// module chunks = 0